import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { BannerContainer, BannerContentWrapper, BannerImage, BannerImageWrapper, BannerWrapper } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/__internal__/styled";
import { optimizeImageUrlFillRectangle } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { trackInsiderMarketingPagePhoneSupportBannerView } from "@faire/web-api--source/events/insider/view/marketingPagePhoneSupportBanner";
import React from "react";
import styled from "styled-components";
export var InsiderPhoneSupportSection = function() {
    var hasPhoneSupport = useInsiderFeatureEligibility().hasPhoneSupport;
    var isSSR = useIsSSR();
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    var ref = useDoActionWhenVisible(function() {
        trackInsiderMarketingPagePhoneSupportBannerView();
    });
    if (!hasPhoneSupport) {
        return null;
    }
    var imageSrc = isTabletAndAbove ? optimizeImageUrlFillRectangle({
        url: "https://cdn.faire.com/fastly/caa42f130ea7a85f38be9f0db9efde497acbe7536bd077d6a9ea8c4ad195f047.jpeg"
    }, isSSR, 440, 480) : optimizeImageUrlFillRectangle({
        url: "https://cdn.faire.com/fastly/51da8c075bdcaa42b55aa1558e34ad4c4e2e86f465cd83a5f22d6cc87849ccf8.png"
    }, isSSR, 375, 410);
    return /*#__PURE__*/ _jsx(BannerWrapper, {
        ref: ref,
        $isPhoneSupportSection: true,
        children: /*#__PURE__*/ _jsxs(BannerContainer, {
            children: [
                /*#__PURE__*/ _jsxs(BannerContentWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(StyledTypography, {
                            variant: {
                                mobileAndAbove: "displaySSerifRegular",
                                desktopAndAbove: "displayMSerifRegular"
                            },
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "UrPO2Q",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Get exclusive access to Faire phone support"
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "2x"
                        }),
                        /*#__PURE__*/ _jsx(StyledTypography, {
                            variant: {
                                mobileAndAbove: "paragraphSansRegular",
                                desktopAndAbove: "subheadingSansRegular"
                            },
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "H2FQ8z",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "As an Insider, you can request a call from us if you ever want to talk through issues or questions with a Faire team member."
                                    }
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(BannerImageWrapper, {
                    align: {
                        mobileAndAbove: "center",
                        tabletAndAbove: "flex-start"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                            tabletAndAbove: /*#__PURE__*/ _jsx(BannerImage, {
                                src: imageSrc
                            })
                        }),
                        /*#__PURE__*/ _jsx(SavingsSummaryWrapper, {
                            $mobileBackgroundImage: imageSrc,
                            align: "center",
                            justify: "flex-end",
                            children: /*#__PURE__*/ _jsx(PhoneSupportImage, {
                                src: optimizeImageUrlFillRectangle({
                                    url: "https://cdn.faire.com/fastly/da5f7357ee600e19693816dfd969c495862f9bc12f39b1b4e81fe92d25e7b4f0.png"
                                }, isSSR, 324, 116)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var StyledTypography = styled(Typography).withConfig({
    componentId: "sc-dcab251d-0"
})([
    "max-width:300px;",
    "{max-width:350px;}"
], responsiveMediaQueries.tabletAndAbove);
var SavingsSummaryWrapper = styled(Column).withConfig({
    componentId: "sc-dcab251d-1"
})([
    "background:url(",
    ");width:100%;",
    "{padding:",
    ";background-position:center center;height:500px;}",
    "{background:unset;width:auto;padding:0;position:absolute;bottom:30px;left:-40px;}",
    "{bottom:auto;top:208px;left:-162px;}"
], function(param) {
    var $mobileBackgroundImage = param.$mobileBackgroundImage;
    return $mobileBackgroundImage;
}, responsiveMediaQueries.mobile, getSpacing("8x", 0), responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
var PhoneSupportImage = styled.img.withConfig({
    componentId: "sc-dcab251d-2"
})([
    "width:324px;height:116px;",
    "{width:260px;height:94px;}"
], responsiveMediaQueries.tablet);
